import { z } from 'zod'

export const customerSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  contact_person: z.string().optional().nullable(),
  phone: z.string().optional(),
  email: z.string().email('Invalid email').optional().or(z.literal('')),
  address: z.string().optional(),
  contact_preference: z.enum(['phone', 'email', 'text', 'in_person']).optional(),
  tags: z.array(z.string()).default([]),
  notes: z.string().optional(),
})

export type CustomerFormData = z.infer<typeof customerSchema>
